var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarmHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "#545454",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.706 3.95a1.593 1.593 0 0 0-2.014 1.156h-.004a9.518 9.518 0 0 1 1.91 1.92 1.593 1.593 0 0 0 .108-3.076zm-3.028-1a3.596 3.596 0 0 0-.744 1.11 9.428 9.428 0 0 0-3.933-.854 9.428 9.428 0 0 0-3.933.854 3.597 3.597 0 1 0-4.7 4.73 9.43 9.43 0 0 0-.83 3.88c0 2.22.765 4.263 2.047 5.878L2.24 20.89a1.002 1.002 0 0 0 1.417 1.417l2.33-2.33a9.424 9.424 0 0 0 6.013 2.154c2.257 0 4.33-.79 5.956-2.108l2.284 2.284a1.002 1.002 0 1 0 1.417-1.417l-2.286-2.286a9.423 9.423 0 0 0 2.092-5.936 9.429 9.429 0 0 0-.83-3.88 3.595 3.595 0 0 0-.344-6.756 3.597 3.597 0 0 0-3.612.918zM4.364 7.08a9.518 9.518 0 0 1 2.078-2.07l-.146.04A1.593 1.593 0 1 0 4.38 7.02l-.015.06zm7.637-1.87a7.46 7.46 0 1 0 0 14.918A7.46 7.46 0 0 0 12 5.21zm0 1.38c.553 0 1.002.45 1.002 1.003v5.076c0 .373-.207.715-.538.888l-3.5 1.83a1.002 1.002 0 1 1-.928-1.775l2.962-1.55v-4.47c0-.553.449-1.001 1.002-1.001z",
    fill: "{fill}"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmHeader);
export default __webpack_public_path__ + "static/media/alarmHeader.e8327ed6c175ac011de0f5616ac86499.svg";
export { ForwardRef as ReactComponent };